import Swal from 'sweetalert2';

export class AvantoAlert {
    static toast(
        toastType: 'success' | 'warning' | 'error' | 'info' | 'question',
        text: string,
        toastPosition?: 'top' | 'top-start' | 'top-end' | 'top-left' | 'top-right' | 'center' | 'center-start' | 'center-end' | 'center-left' | 'center-right' | 'bottom' | 'bottom-start' | 'bottom-end' | 'bottom-left' | 'bottom-right',
        toastDurationInMs?: number) {
        const pos = toastPosition != null ? toastPosition : 'bottom-start';
        const duration = toastDurationInMs != null ? toastDurationInMs : 6000
        const topRightToast = Swal.mixin({ toast: true, position: pos, showConfirmButton: false, timer: duration })
        topRightToast.fire({ type: toastType, title: text })
    }
}